import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  PublicMeetingActionResponse,
  PublicMeetingCancelRequest,
  PublicMeetingRescheduleRequest,
} from '../models/meeting.model';

/**
 * INC 79 — API pública de los enlaces "Cancelar / Reprogramar" del correo
 * (`/#/meeting-action/:token`), bajo `/api/public/meeting-action/**`, SIN JWT.
 *
 * Antes esta pantalla llamaba a `/api/meeting-action-tokens/lookup`,
 * `GET /api/meetings/{id}` y `PUT /api/meetings/{id}`: los tres exigen token de sesión,
 * así que el invitado anónimo solo recibía 401 y la página quedaba muerta. Aquí el token
 * del enlace es la credencial y el backend resuelve la reunión y aplica las reglas.
 */
@Injectable({ providedIn: 'root' })
export class PublicMeetingActionApiService {
  private url = `${environment.apiUrl}api/public/meeting-action`;

  constructor(private http: HttpClient) {}

  resolve(token: string): Observable<PublicMeetingActionResponse> {
    return this.http.get<PublicMeetingActionResponse>(`${this.url}/${token}`);
  }

  cancel(token: string, body: PublicMeetingCancelRequest): Observable<PublicMeetingActionResponse> {
    return this.http.post<PublicMeetingActionResponse>(`${this.url}/${token}/cancel`, body);
  }

  reschedule(
    token: string,
    body: PublicMeetingRescheduleRequest
  ): Observable<PublicMeetingActionResponse> {
    return this.http.post<PublicMeetingActionResponse>(`${this.url}/${token}/reschedule`, body);
  }
}
